module.exports = __webpack_public_path__ + "static/media/2-N-okas.574cff72.webp";